export type ProofStatus = "draft" | "verified" | "published";

export interface SchoolPartnership {
  slug: string;
  schoolName: string;
  partnershipType: string;
  status: ProofStatus;
  indexable: boolean;
  startDate?: string;
  academicTerm?: string;
  grades?: string;
  useDescription: string;
  publicWebsiteUrl?: string;
  publicCorroborationUrl?: string;
  approvedQuote?: string;
  logoUrl?: string;
  logoPermission: boolean;
  caseStudySlug?: string;
}

export type EvidenceKind = "observed_feedback" | "participation_data" | "survey_feedback" | "measured_outcome";

export interface CaseStudyRecord {
  slug: string;
  title: string;
  summary: string;
  status: ProofStatus;
  indexable: boolean;
  schoolSlug?: string;
  context: string;
  need: string;
  programme: string;
  participation: string;
  observations: string[];
  limitations: string[];
  evidenceKinds: EvidenceKind[];
  approvedQuote?: string;
  sourceLinks: Array<{ label: string; url: string }>;
  datePublished?: string;
  dateUpdated?: string;
}

export interface PressMention {
  slug: string;
  publication: string;
  headline: string;
  publicationDate: string;
  coverageType: "feature" | "founder_interview" | "expert_quote" | "research_mention" | "podcast";
  originalUrl: string;
  neutralSummary: string;
  status: ProofStatus;
  indexable: boolean;
  journalist?: string;
}

// Deliberately empty until permission, corroboration and factual details are recorded.
export const SCHOOL_PARTNERSHIPS: SchoolPartnership[] = [];
export const CASE_STUDIES: CaseStudyRecord[] = [];
export const PRESS_MENTIONS: PressMention[] = [];

export const PUBLISHED_SCHOOLS = SCHOOL_PARTNERSHIPS.filter(
  (record) => record.status === "published" && record.indexable && Boolean(record.publicCorroborationUrl),
);
export const PUBLISHED_CASE_STUDIES = CASE_STUDIES.filter(
  (record) => record.status === "published" && record.indexable && record.sourceLinks.length > 0,
);
export const PUBLISHED_PRESS = PRESS_MENTIONS.filter(
  (record) => record.status === "published" && record.indexable && record.originalUrl.startsWith("https://"),
);
export const CASE_STUDY_BY_SLUG = new Map(PUBLISHED_CASE_STUDIES.map((record) => [record.slug, record]));
